import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore, useAppStore } from './store';
import { BootScreen } from './components/BootScreen';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { CarWash } from './pages/CarWash';
import { PriceOTron } from './pages/PriceOTron';
import { Settings } from './pages/Settings';
import { Login } from './pages/Login';

function App() {
  const { hasBooted, setHasBooted } = useAppStore();
  const { isAuthenticated } = useAuthStore();

  // Show boot screen on first load
  if (!hasBooted) {
    return <BootScreen onComplete={() => setHasBooted(true)} />;
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={isAuthenticated ? <Layout /> : <Navigate to="/login" />}
      >
        <Route index element={<Dashboard />} />
        <Route path="car-wash" element={<CarWash />} />
        <Route path="gas-prices" element={<PriceOTron />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
